<div class="addContainer">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about"> ANTECEDENTES DESTACABLES DE: <br> <span
          style="color: #00a5b8">{{ dialogTitle }}</span>
        </div>
      </div>
    </div>
    <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div [hidden]="patient.patologias.length < 1" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 m-t-20">
      <mat-list>
        <h5>PATOLOGIAS</h5>
        <mat-list-item *ngFor="let row of patient.patologias">* {{ row.nameCIM10 }}</mat-list-item>
      </mat-list>
    </div>
    <div [hidden]="patient.alergias.length < 1" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 m-t-20">
      <mat-list>
        <h5>ALERGIAS</h5>
        <mat-list-item *ngFor="let row of patient.alergias">* {{
            row.nameAllergy
          }}
        </mat-list-item>
      </mat-list>
    </div>
    <div [hidden]="patient.molecules.length < 1" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 m-t-20">
      <mat-list>
        <h5>MOLECULAS</h5>
        <mat-list-item *ngFor="let row of patient.molecules">* {{
            row.nameMolecule
          }}
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
